<template>
  <div class="author-header mt-1 mr-2">
    <span>
      By
    </span>
    <router-link :to="{ name: `${link.path}.view`, params: { [link.id]: author.id }}">
      {{ author.name }}
    </router-link>

    <span v-if="author.job_title">
      - {{ author.job_title }}
    </span>

    <span v-if="link.type === 'account' && author && author.account">
      @
      <router-link :to="`/accounts/${author.account_id}`">
        {{ author.account.name }}
      </router-link>
    </span>

    <span v-if="link.type === 'channel' && author.channel">
      @
      <router-link :to="`/channels/${author.channel.id}`">
        {{ author.channel.name }}
      </router-link>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    author: {
      required: true,
      type: Object,
    },
    link: {
      type: Object,
      required: true,
    },
  },
}
</script>
